import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=7f687f72&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SettingsModal.vue?vue&type=script&lang=ts&"
export * from "./SettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f687f72')) {
      api.createRecord('7f687f72', component.options)
    } else {
      api.reload('7f687f72', component.options)
    }
    module.hot.accept("./SettingsModal.vue?vue&type=template&id=7f687f72&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('7f687f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Favorites/SettingsModal.vue"
export default component.exports